'use client'
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import React, {useRef} from "react";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {hover, text} from "@/styles/globalStyleVars";
import Title from "@/components/Title";
import MediaBox from "@/components/media/MediaBox";
import Button from "@/components/Button";
import SweeperNav from "@/components/swiper/SweeperNav";
import Slider, {Slide} from "@/components/swiper";

const prev = ` <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<circle cx="20" cy="20" r="19.5" />
<path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572C20.5506 27.662 20.5506 27.3454 20.3554 27.1501L13.7071 20.5018L27.5037 20.5018C27.7798 20.5018 28.0037 20.278 28.0037 20.0018C28.0037 19.7257 27.7798 19.5018 27.5037 19.5018L13.7071 19.5018L20.3554 12.8536C20.5506 12.6583 20.5506 12.3417 20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464L12.1464 19.6483C12.097 19.6977 12.06 19.755 12.0356 19.8161C12.0179 19.8605 12.0068 19.9069 12.0023 19.9539C12.0008 19.9698 12 19.9858 12 20.0018C12 20.0018 12 20.0018 12 20.0018C12 20.0194 12.0009 20.037 12.0028 20.0545C12.0073 20.0979 12.0175 20.1407 12.0334 20.1819C12.0578 20.2451 12.0954 20.3044 12.1464 20.3554L19.6483 27.8572Z" fill="black"/>
</svg>`
const next = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
                      <circle cx='20' cy='20' r='19.5' />
                      <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M20.3554 12.1464C20.1601 11.9512 19.8435 11.9512 19.6483 12.1464C19.453 12.3417 19.453 12.6583 19.6483 12.8536L26.2966 19.5018H12.5C12.2239 19.5018 12 19.7257 12 20.0018C12 20.278 12.2239 20.5018 12.5 20.5018H26.2966L19.6483 27.1501C19.453 27.3454 19.453 27.662 19.6483 27.8572C19.8435 28.0525 20.1601 28.0525 20.3554 27.8572L27.8572 20.3554C27.9067 20.3059 27.9436 20.2487 27.968 20.1876C27.9877 20.1383 27.9999 20.0852 28.0029 20.0297C28.0034 20.0204 28.0037 20.0111 28.0037 20.0018C28.0037 19.9874 28.0031 19.973 28.0018 19.9587C27.9978 19.9121 27.9873 19.866 27.9703 19.8218C27.9459 19.7585 27.9082 19.6993 27.8572 19.6483Z'
                          fill='black'
                          class="path"
                      />
                 </svg>`

const MediaCenter = ({data}) => {

    let sliderRef = useRef();



    return (
        <StyledBlog className='blog-slider pt-120 pb-120'>

            <Container >
                <Row className="full-title ">
                    <Col md={12} className={'d-flex justify-content-between'}>
                        <Title text={'Our Latest Blogs'}/>

                        {
                            data && data?.length > 3 &&
                            <div className="slider-nav">
                                <SweeperNav prevSvg={prev} prevId={'slider_prev_media'} nextID={'slider_next_media'} nextSvg={next}/>
                            </div>

                        }

                    </Col>

                </Row>
            </Container>


            <Container>
                <div className={` fade-up blog-slider__slider-wrap`}>
                    <div className="blog-slider__slider-wrap__inner">
                        {
                            data && data?.length > 3 ?
                            <Slider loop={true}
                                    spaceBetween={30}
                                    slidesPerView={3}
                                    allowSlideNext={true}
                                    allowSlidePrev={true}
                                    allowTouchMove={true}
                                    speed={2000}
                                    navigationLeft={'.slider_prev_media'}
                                    navigationRight={'.slider_next_media'}
                                    navigation={{
                                        prevEl: '.slider_prev_media',
                                        nextEl: '.slider_next_media',
                                    }}
                                    modules={[Autoplay, Pagination, Navigation]}
                                    breakpoints={{
                                        300: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    ref={sliderRef}>

                                {
                                    data && data?.length > 0 &&
                                    data?.map((e, index) => {
                                        return (
                                            <Slide key={index}>
                                                <MediaBox
                                                    title={e?.post_title}
                                                    img={e?.thumb}
                                                    date={e?.date}
                                                    type={e?.type?.[0]?.name}
                                                    src={e?.post_name}
                                                />
                                            </Slide>
                                        )
                                    })
                                }
                            </Slider> :
                                <Row>

                                    {

                                        data && data?.length > 0 &&
                                        data?.map((e, index) => {
                                            return (
                                                <Col md={4} key={index}>
                                                    <MediaBox
                                                        title={e?.post_title}
                                                        img={e?.thumb}
                                                        date={e?.date}
                                                        type={e?.type?.[0]?.name}
                                                        src={e?.post_name}
                                                    />
                                                </Col>
                                            )
                                        })

                                    }

                                </Row>

                        }

                    </div>
                </div>
                <Row className={'justify-content-center align-items-center'}>
                    <div >
                        <Button src={'/news-events'} text={'Explore All News'} border={`1px`} borderColor={`${text}`} color={`${text}`} hoverBackground={`${hover}`}/>
                    </div>
                </Row>
            </Container>
        </StyledBlog>
    );
};

const StyledBlog = styled.section`
    background-color: #FAFAFA;


    .hover:after {
        z-index: 0 !important;
    }

    .sub-title {
        margin: 0 0 20px 0;
        font-weight: 500;
    }

    .full-title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        //margin: 0 0 80px 0;


        .col-md-3 {
            padding-left: 40px !important;
            padding-right: 0px !important;
        }

    }

    .blog-title {
        padding-left: 0;

        h3 {
            text-transform: uppercase;
            font-size: 32px;
            font-weight: 900;

            span {
                color: ${hover};
            }
        }
    }

    .slider-nav {
        ul {
            display: flex;

            .slider_next {
                margin-left: 20px;

            }


        }
        .circle{
            border: 1px solid black;
            &:hover{
                border: 1px solid ${hover};

            }
        }

        li {
            //height: 50px;
            //width: 50px;
            //background-color: #56575A;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            border-radius: 50%;
            //cursor: pointer;

            &:nth-of-type(1) {
                margin-right: -10px;
            }

        }
    }


    h2 {
        font-weight: 800;
    }

    .hover {
        cursor: pointer;

        &:after {
            z-index: 0;
        }
    }

    svg {
        z-index: 9999;
    }

    .swiper-button-disabled {
        opacity: unset !important;
    }

    .swiper-button-next, .swiper-button-prev {
        position: absolute;
        height: 40px;
        width: 40px;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 99;
        background-color: #F16A11;
    }

    .swiper-button-next, .swiper-button-prev, .swiper-pagination {
        opacity: 0;
        visibility: hidden;
    }

    .swiper-initialized {
        margin-left: ${props => props.offset + 15}px;
        padding-right: ${props => props.offset + 15}px;
    }

    .blog-slider {
        &__slider-wrap {
            &__inner {
                .blog-single {
                    &__inner {
                        padding-top: 115%;
                    }
                }
            }
        }
    }

    .slider-nav-mobile {
        margin-top: 80px;
    }

    @media (max-width: 767px) {
        .swiper-initialized {
            margin: 0;
            padding: 0;
        }

        .blog-slider {
            &__slider-wrap {
                margin: 0;
            }
        }

        .full-title {
            display: unset;
            margin: 0;

            .mobile {
                margin-bottom: 40px;
            }

            .col-md-12 {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

        }

        .blog-title {
            padding: 0;
            margin-bottom: 40px;
        }

        .blog-button {
            //margin-bottom: 40px;
        }

        .blog-single {
            .blog-single__inner {
                padding-top: calc(440 / 375 * 100%);

                &__content {
                    &__bottom {
                        h3 {
                            color: ${hover};

                            p {
                                color: #FFFFFF;
                            }
                        }
                    }
                }

                &:hover {
                    .blog-single__inner__content__bottom {
                        h3 {
                            color: #ffffff;
                        }
                    }
                }
            }

            .blog-single__inner__content__top {
                .upper, h2 {
                    left: 15px;
                    right: 15px;
                }
            }

            .blog-single__inner__content__bottom h4, .blog-single__inner__content__bottom p {
                left: 15px;
                right: 15px;
            }
        }

        .slider-nav-mobile {
            margin-top: 40px;
        }

    }

`;
export default React.memo(MediaCenter);